var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8362 10.6896L7.13453 6.00001L11.8362 1.31038C12.1367 1.01061 12.1367 0.524609 11.8361 0.224883C11.5357 -0.0748934 11.0484 -0.0748934 10.7478 0.224883L6.04619 4.91446L1.34451 0.224833C1.04402 -0.0749442 0.556718 -0.0749442 0.256172 0.224833C-0.044375 0.524609 -0.044375 1.01061 0.256172 1.31038L4.95785 6.00001L0.256172 10.6896C-0.044375 10.9894 -0.044375 11.4754 0.256172 11.7752C0.406445 11.9251 0.603406 12 0.800316 12C0.997278 12 1.19424 11.9251 1.34451 11.7752L6.04619 7.08556L10.7479 11.7752C10.8981 11.9251 11.0951 12 11.2921 12C11.489 12 11.686 11.9251 11.8362 11.7752C12.1367 11.4754 12.1367 10.9894 11.8362 10.6896Z",
    fill: "#29185E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.dd49ab3ddd129f8093903b6820bd77e5.svg";
export { ForwardRef as ReactComponent };